import * as React from 'react';

import { CollectionView } from '@grapecity/wijmo';

import { Card, Col, Form, Row, Container } from 'react-bootstrap';
import { useEffect, useState, useRef } from 'react';

import { useRestApi } from 'context/RestApiContext';
import { useMaster } from 'context/MasterContext';

import AnalysisSoudan from 'views/Analysis/AnalysisSoudan';
import AnalysisAge from 'views/Analysis/AnalysisAge';
import AnalysisClientType from 'views/Analysis/AnalysisClientType';
import AnalysisUkeType from 'views/Analysis/AnalysisUkeType';
import AnalysisArea from 'views/Analysis/AnalysisArea';
import AnalysisVisitReason from 'views/Analysis/AnalysisVisitReason';
import AnalysisVisitReasonRepeat from 'views/Analysis/AnalysisVisitReasonRepeat';
import AnalysisKei from 'views/Analysis/AnalysisKei';
import AnalysisKingaku from 'views/Analysis/AnalysisKingaku';
import AnalysisSalseTan from 'views/Analysis/AnalysisSalseTan';
import AnalysisGenbaTan from 'views/Analysis/AnalysisGenbaTan';
import AnalysisKoujiKbn from 'views/Analysis/AnalysisKoujiKbn';
import AnalysisKoujiKbnUser from 'views/Analysis/AnalysisKoujiKbnUser';
import AnalysisKoujiKbnCorp from 'views/Analysis/AnalysisKoujiKbnCorp';
import AnalysisKoujiKbnPublic from 'views/Analysis/AnalysisKoujiKbnPublic';
import AnalysisJuchuKbn from 'views/Analysis/AnalysisJuchuKbn';

import SelectComponent from 'components/Input/SelectComponent';
import {
  AnalysisKind,
  AnalysisKinds,
  ComparisonKind,
  ComparisonKinds,
} from 'views/Analysis/analysisUtils';
import { getCurrentPeriod, getPeriods } from 'utils/dateUtils';

import './Analysis.css';

// 分析画面
function Analysis() {
  const restApi = useRestApi();
  const master = useMaster();

  // 期
  const periods = getPeriods();
  // 選択中の期
  const [selectedPeriod, setSelectedPeriod] = useState(getCurrentPeriod());
  // 選択中の分析種別
  const [analysisKind, setAnalysisKind] = useState(AnalysisKind.SOUDAN);
  // 選択中の比較種別
  const [comparisonKind, setComparisonKind] = useState(ComparisonKind.CURRENT_BEFORE);

  // 選択中の営業担当コード
  const [salesTanCd, setSalesTanCd] = useState(0);
  // 選択中の現場担当コード
  const [genbaTanCd, setGenbaTanCd] = useState(0);
  // 来店きっかけ
  const [visitReasons, setVisitReasons] = useState([]);
  // 見積依頼件数
  const [quoteList, setQuoteList] = useState(new CollectionView([]));
  // 選択中のタブ
  const [selectedTab, setSelectedTab] = useState('count');

  useEffect(() => {
    restApi.post(
      `/api/analysis/${selectedPeriod}`,
      { SALES_TAN_CD: salesTanCd, GENBA_TAN_CD: genbaTanCd },
      (data) => {
        setQuoteList(new CollectionView(data.analysisData));
        setVisitReasons(data.visitReasons);
      }
    );
  }, [selectedPeriod, salesTanCd, genbaTanCd]);

  // タブの選択処理
  const handleOnClickTab = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <Container fluid className="m-0 pl-1 pt-1">
      <Row className="mb-2">
        {/* 期選択コンボボックス */}
        <Col className="pl-3" md="12" style={{ display: 'flex' }}>
          <div style={{ width: '88px' }}>
            <label className="item-header-label">期</label>
            <SelectComponent
              value={selectedPeriod}
              onChange={(e) => {
                setSelectedPeriod(e.value);
              }}
            >
              {periods.map((p) => (
                <option key={p} value={p}>
                  {p}期
                </option>
              ))}
            </SelectComponent>
          </div>
          {/* 分析種別（相談件数、契約件数、契約金額） */}
          <div style={{ width: '120px' }} className="ml-2">
            <label className="item-header-label">分析種別</label>
            <SelectComponent
              value={analysisKind}
              onChange={(e) => {
                setAnalysisKind(e.value);
              }}
            >
              {AnalysisKinds.map((kind) => (
                <option key={kind.key} value={kind.key}>
                  {kind.value}
                </option>
              ))}
            </SelectComponent>
          </div>
          {/* 比較種別（昨対比、工事/小工事・管理） */}
          <div style={{ width: '160px' }} className="ml-2">
            <label className="item-header-label">比較種別</label>
            <SelectComponent
              value={comparisonKind}
              onChange={(e) => {
                setComparisonKind(e.value);
              }}
            >
              {ComparisonKinds.map((x) => (
                <option key={x.key} value={x.key}>
                  {x.value}
                </option>
              ))}
            </SelectComponent>
          </div>
          {/* 営業担当 */}
          <div className="ml-2">
            <label className="item-header-label">営業担当</label>
            <SelectComponent value={salesTanCd} onChange={(e) => setSalesTanCd(e.value)}>
              <option value={0}></option>
              {master.salesStaff.map((x, i) => (
                <option key={i} value={x['id']}>
                  {x['name']}
                </option>
              ))}
            </SelectComponent>
          </div>
          {/* 現場担当 */}
          <div className="ml-2">
            <label className="item-header-label">現場担当</label>
            <SelectComponent value={genbaTanCd} onChange={(e) => setGenbaTanCd(e.value)}>
              <option value={0}></option>
              {master.genbaStaff.map((x, i) => (
                <option key={i} value={x['id']}>
                  {x['name']}
                </option>
              ))}
            </SelectComponent>
          </div>
        </Col>
      </Row>
      <div style={{ display: 'flex' }}>
        {analysisKind == AnalysisKind.SOUDAN && (
          <div
            className={`pl-2 panel-label ${selectedTab == 'count' && 'selected'}`}
            onClick={() => handleOnClickTab('count')}
          >
            相談件数
          </div>
        )}
        {analysisKind == AnalysisKind.KEIYAKU && (
          <div
            className={`pl-2 panel-label ${selectedTab == 'count' && 'selected'}`}
            onClick={() => handleOnClickTab('count')}
          >
            契約件数
          </div>
        )}
        {analysisKind == AnalysisKind.KINGAKU && (
          <div
            className={`pl-2 panel-label ${selectedTab == 'count' && 'selected'}`}
            onClick={() => handleOnClickTab('count')}
          >
            契約金額
          </div>
        )}
        <div
          className={`pl-2 panel-label ${selectedTab == 'age' && 'selected'}`}
          onClick={() => handleOnClickTab('age')}
        >
          年代別
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'clientType' && 'selected'}`}
          onClick={() => handleOnClickTab('clientType')}
        >
          顧客区分
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'ukeType' && 'selected'}`}
          onClick={() => handleOnClickTab('ukeType')}
        >
          受付方法
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'area' && 'selected'}`}
          onClick={() => handleOnClickTab('area')}
        >
          重点エリア
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'visit' && 'selected'}`}
          onClick={() => handleOnClickTab('visit')}
          style={{ width: '135px' }}
        >
          来店きっかけ
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'juchu_kbn' && 'selected'}`}
          onClick={() => handleOnClickTab('juchu_kbn')}
        >
          受注区分
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'kouji_kbn' && 'selected'}`}
          onClick={() => handleOnClickTab('kouji_kbn')}
        >
          工事区分
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'user' && 'selected'}`}
          onClick={() => handleOnClickTab('user')}
        >
          個人
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'corp' && 'selected'}`}
          onClick={() => handleOnClickTab('corp')}
        >
          法人
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'public' && 'selected'}`}
          onClick={() => handleOnClickTab('public')}
        >
          公共
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'salesTan' && 'selected'}`}
          onClick={() => handleOnClickTab('salesTan')}
        >
          営業担当
        </div>
        <div
          className={`pl-2 panel-label ${selectedTab == 'genbaTan' && 'selected'}`}
          onClick={() => handleOnClickTab('genbaTan')}
        >
          現場担当
        </div>
      </div>

      {/* 分析(相談件数) */}
      {analysisKind == AnalysisKind.SOUDAN && selectedTab == 'count' && (
        <div className="panel-tab">
          <AnalysisSoudan
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            comparisonKind={comparisonKind}
          ></AnalysisSoudan>
        </div>
      )}
      {/** 分析(契約件数) */}
      {analysisKind == AnalysisKind.KEIYAKU && selectedTab == 'count' && (
        <div className="panel-tab">
          <AnalysisKei
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            comparisonKind={comparisonKind}
          ></AnalysisKei>
        </div>
      )}
      {/** 分析(契約金額) */}
      {analysisKind == AnalysisKind.KINGAKU && selectedTab == 'count' && (
        <div className="panel-tab">
          <AnalysisKingaku
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            comparisonKind={comparisonKind}
          ></AnalysisKingaku>
        </div>
      )}
      {/* 分析(年代別) */}
      {selectedTab == 'age' && (
        <div className="panel-tab">
          <AnalysisAge
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisAge>
        </div>
      )}
      {/* 分析(顧客区分) */}
      {selectedTab == 'clientType' && (
        <div className="panel-tab">
          <AnalysisClientType
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisClientType>
        </div>
      )}
      {/* 分析(受付方法) */}
      {selectedTab == 'ukeType' && (
        <div className="panel-tab">
          <AnalysisUkeType
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisUkeType>
        </div>
      )}
      {/* 分析(重点エリア) */}
      {selectedTab == 'area' && (
        <div className="panel-tab">
          <AnalysisArea
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisArea>
        </div>
      )}
      {/* 分析(来店きっかけ新規) */}
      {selectedTab == 'visit' && (
        <div className="panel-tab">
          <AnalysisVisitReason
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisVisitReason>
        </div>
      )}

      {/* 分析(受注区分) */}
      {selectedTab == 'juchu_kbn' && (
        <div className="panel-tab">
          <AnalysisJuchuKbn
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisJuchuKbn>
        </div>
      )}
      {/* 分析(工事区分) */}
      {selectedTab == 'kouji_kbn' && (
        <div className="panel-tab">
          <AnalysisKoujiKbn
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisKoujiKbn>
        </div>
      )}
      {/* 分析(工事種・個人) */}
      {selectedTab == 'user' && (
        <div className="panel-tab">
          <AnalysisKoujiKbnUser
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisKoujiKbnUser>
        </div>
      )}
      {/* 分析(工事種・法人) */}
      {selectedTab == 'corp' && (
        <div className="panel-tab">
          <AnalysisKoujiKbnCorp
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisKoujiKbnCorp>
        </div>
      )}
      {/* 分析(工事種・公共) */}
      {selectedTab == 'public' && (
        <div className="panel-tab">
          <AnalysisKoujiKbnPublic
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisKoujiKbnPublic>
        </div>
      )}
      {/* 分析(営業担当) */}
      {selectedTab == 'salesTan' && (
        <div className="panel-tab">
          <AnalysisSalseTan
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisSalseTan>
        </div>
      )}
      {/* 分析(現場担当) */}
      {selectedTab == 'genbaTan' && (
        <div className="panel-tab">
          <AnalysisGenbaTan
            quoteList={quoteList}
            selectedPeriod={selectedPeriod}
            periods={periods}
            visitReasons={visitReasons}
            analysisKind={analysisKind}
            comparisonKind={comparisonKind}
          ></AnalysisGenbaTan>
        </div>
      )}
    </Container>
  );
}
export default Analysis;
